import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { forbidAuthenticationInsertion } from '@core/constants/interceptor.const';

import { map } from 'rxjs';
import { TokenService } from '../services/token.service';
import { loginRoutes } from '../constants/interceptor.constant';
import { TOKENS } from '@core/types';

export const TokenRetrievalInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const tokenService = inject(TokenService);
  // const cookieService = inject(CookieStorageService)
  if (loginRoutes.some((route) => req.url.includes(route))) {
    return next(req).pipe(
      map((event: HttpEvent<unknown>) => {
        if (event instanceof HttpResponse) {
          tokenService.setTokens(event);
        }
        return event;
      }),
    );
  } else {
    const isCookiesLogin = tokenService.isCookiesLogin();
    const accessToken = tokenService.getAuthToken(TOKENS.accessToken);
    const shouldInsertAuthentication = !forbidAuthenticationInsertion(req.url);

    if (shouldInsertAuthentication && isCookiesLogin) {
      const clientId = tokenService.getItem('CLIENT_ID');
      const isThemeClientReq = req.url.includes('/theme-by-client-id');
      let headers = req.headers;

      if (!isThemeClientReq && clientId) {
        headers = headers.set('client-id', clientId);
      }

      return next(req.clone({ headers, withCredentials: true }));
    }

    if (shouldInsertAuthentication && accessToken) {
      const clientId = tokenService.getItem('CLIENT_ID');
      const isThemeClientReq = req.url.includes('/theme-by-client-id');
      let headers = req.headers.set('Authorization', `Bearer ${accessToken}`);

      if (!isThemeClientReq && clientId) {
        headers = headers.set('client-id', clientId);
      }

      const modifiedReq = req.clone({ headers });
      return next(modifiedReq);
    } else {
      return next(req);
    }
  }
};
